// Store Swiper instances globally
let featuredProductSwiper = null;
let featuredProductThumbsSwiper = null;

function initiateCartPopupSlider() {
  try {

    // Destroy existing Swipers if they exist
    if (featuredProductSwiper) {
      featuredProductSwiper.destroy(true, true);
      featuredProductSwiper = null;
    }
    if (featuredProductThumbsSwiper) {
      featuredProductThumbsSwiper.destroy(true, true);
      featuredProductThumbsSwiper = null;
    }

    // Initialize thumbnails first
    featuredProductThumbsSwiper = new Swiper(`.cus-cart-popup-slider-thumbs`, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize main slider with thumbs reference
    featuredProductSwiper = new Swiper(`.cus-cart-popup-slider`, {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      thumbs: {
        swiper: featuredProductThumbsSwiper,
      },
    });
  } catch (error) {
    console.log("===> initiateCartPopupSlider error", error);
  }
}

function openCustomCartModal(product) {
  const modal = document.querySelector(".custom_cart_popup");


  // Update text content
  modal.querySelector(".modal-featured-product-title").innerText =
    product.title;
  modal.querySelector(".modal-featured-product-paragraph").innerHTML =
    product.body_html;
  modal.querySelector(".product-price .price").innerText =
    "$" + product.variants[0].price;

  modal
    .querySelector("variant-selection")
    .setAttribute("variant", product.variants[0].id);

  // === Update Main Slider (Upper Slider) ===
  const mainSliderWrapper = modal.querySelector(
    ".cus-cart-popup-slider .swiper-wrapper"
  );
  mainSliderWrapper.innerHTML = ""; // Clear existing slides

  product.images.forEach((image) => {
    const slide = document.createElement("div");
    slide.classList.add("swiper-slide");

    const img = document.createElement("img");
    img.classList.add("modal-featured-product-image");
    img.src = image.src;
    img.alt = image.alt;

    slide.appendChild(img);
    mainSliderWrapper.appendChild(slide);
  });

  // === Update Thumbnail Slider ===
  const thumbnailContainer = modal.querySelector(".thumbnails-wrapper");
  thumbnailContainer.innerHTML = ""; // Clear existing thumbnails

  product.images.forEach((image) => {
    const slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.style.width = "92.5px";
    slide.style.marginRight = "10px";

    const thumbnail = document.createElement("img");
    thumbnail.classList.add("modal-featured-product-thumbnail");
    thumbnail.src = image.src;
    thumbnail.alt = image.alt;

    slide.appendChild(thumbnail);
    thumbnailContainer.appendChild(slide);
  });

  let popupForm = modal.querySelector(".cust-prod-form");
  popupForm.id = `cus_product_form_${product.id}`;

  // Re-initialize Swipers
  initiateCartPopupSlider();

  // Show modal
  modal.style.display = "flex";

  // Remove any existing click event listener
  window.removeEventListener("click", handleOutsideClick);
  window.addEventListener("click", handleOutsideClick);
}

function handleOutsideClick(event) {
  if (event.target === modal) {
    modal.style.display = "none";
  }
}

function closeCustomPopupModal(span) {
  var modal = span.closest(".featured-product-modal");
  modal.style.display = "none";

  // Remove the click event listener when modal is closed
  window.removeEventListener("click", handleOutsideClick);
}

document.addEventListener(
  "click",
  function (event) {
    
    const el = event.target.closest("[href], [data-instant-href]");
    
    const hrefValue = el.getAttribute("href");
    const dataHrefValue = el.getAttribute("data-instant-href");



    if (
      (hrefValue && hrefValue.trim() === "/triggerCustomCartPopup") ||
      (dataHrefValue && dataHrefValue.trim() === "/triggerCustomCartPopup")
    ) {
      event.preventDefault();
      event.stopPropagation();

      const productUrl = el.getAttribute("data-instant-form-product-url");
      if (!productUrl) {
        console.warn("No product URL found on trigger");
        return;
      }

      fetch(`${productUrl}.json`)
        .then((res) => res.json())
        .then((product) => {
          openCustomCartModal(product.product);
        });
    }
  },
  true
); // Use capture phase to beat builder's own listeners
